import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import type { RetouchingRootState } from '../../../selectors/retouchingState';
import { selectRetouchingEditPath } from '../../../selectors';

const EditLink = styled(Link)`
  color: #479de6;
  display: block;
  width: 100%;
  padding-top: 8px;
  &:hover {
    color: #479de6;
  }
`;

interface CartItemEditRetouchingLinkProps {
  cartItem?: { isRetouching?: boolean } | null;
  // The cart order's key (`${eventId}-${studentId}`).
  studentId?: string | null;
}

// Every retouching item gets an Edit affordance — the retouching page reopens in
// edit mode, prefilled with the current selection. It is rendered even when there
// are no selections yet, because that is exactly the state the submit-time error
// tells the customer to go fix.
const CartItemEditRetouchingLink: FC<CartItemEditRetouchingLinkProps> = ({
  cartItem,
  studentId = null,
}) => {
  const target = useSelector((state: RetouchingRootState) =>
    selectRetouchingEditPath(state, studentId),
  );
  if (!cartItem?.isRetouching || !target) return null;

  return (
    <EditLink
      to={target}
      className="bnl-cart-item__edit-retouching cursor-pointer"
    >
      Edit
    </EditLink>
  );
};

export default CartItemEditRetouchingLink;
